import React from "react";
import { Box } from "@mui/material";
import { Spinner } from "react-bootstrap";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useSelector } from "react-redux";
import { ExpanderComponentProps } from "react-data-table-component";


function ExpandableChartRow(props: ExpanderComponentProps<any>) {
    const rowData = props.data;

    const isDetailLoading = useSelector(
        (state: any) => state.landingPageReports.isDetailLoading
    );
    const landingPageDetailVisits = useSelector(
        (state: any) => state.landingPageReports.landingPageDetailVisits
    );

    if (isDetailLoading) {
        return (
            <Box sx={{ p: 2 }}>
                <Spinner animation="border" variant="dark" />
            </Box>
        );
    }

    if (!landingPageDetailVisits) {
        return (
            <Box sx={{ p: 2 }}>
                <p>No detail data.</p>
            </Box>
        );
    }

    return (
        <Box sx={{ width: "100%", height: 300 }}>
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={landingPageDetailVisits}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <Line type="monotone" dataKey="total_visit" stroke="#82ca9d" name="Total Visit" />
                </LineChart>
            </ResponsiveContainer>
        </Box>
    );
}

export default ExpandableChartRow;
